import React from 'react';

export type Chip = {
    label: string;
    value: number;
    colorClassName: string;
};

/**
 * A compact row of labelled count chips - for small discrete breakdowns
 * (e.g. dispute aging, overdue vs. due-soon) where the individual counts
 * matter more than their proportion, so a stretched bar isn't the right fit.
 */
export default function BreakdownChips({ chips }: { chips: Chip[] }) {
    return (
        <div className="flex flex-wrap gap-1.5">
            {chips.map((chip) => (
                <div
                    key={chip.label}
                    className="flex items-center gap-1.5 bg-surface-muted rounded-full pl-2 pr-2.5 py-1"
                >
                    <span className={`w-1.5 h-1.5 rounded-full ${chip.colorClassName}`} />
                    <span className="text-xs text-foreground-secondary">{chip.label}</span>
                    <span className="text-xs font-semibold text-foreground">{chip.value}</span>
                </div>
            ))}
        </div>
    );
}
